<template>
  <VTooltip
    :text="_tooltipText"
    position="up"
    :extraClass="`v-time-tooltip ${noPadding ? 'no-pad' : ''}`"
  >
    <span
      :class="{ ['clickable']: onClick }"
      v-on="onClick ? { click: onClick } : {}"
    >
      {{ _textToDisplay }}
    </span>
  </VTooltip>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment";

// components
import VTooltip from "@/components/VTooltip";

export default Vue.component("VTextTooltiped", {
  props: {
    text: VueTypes.any.isRequired,
    tooltipText: VueTypes.string,
    extend: VueTypes.bool.def(true),
    timeOnly: VueTypes.bool.def(true),
    noPadding: VueTypes.bool.def(true),
    onClick: VueTypes.func
  },

  components: {
    VTooltip
  },

  methods: {
    _getFormattedDate() {
      const date = this.text instanceof moment ? this.text : moment(this.text);
      const formatString = this.timeOnly
        ? "h:mm A"
        : `MMM D, YYYY ${this.extend ? "[at] h:mm A" : ""} z`;

      return date.format(formatString);
    }
  },

  computed: {
    _textToDisplay() {
      if (this.text instanceof moment || this.text instanceof Date) {
        return this._getFormattedDate();
      }

      return this.text;
    },

    _tooltipText() {
      return this.tooltipText ? this.tooltipText : this._textToDisplay;
    }
  }
});
</script>

<style lang="scss">
.v-tooltip__wrapper.v-time-tooltip {
  align-items: flex-start;
  &.no-pad {
    [tooltip][flow^="up"]::after {
      padding: 0;
    }
  }

  [tooltip][flow^="up"]::after {
    border-radius: 3px;
    background: #fff;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.15);
  }

  /deep/ span {
    &.clickable {
      &:hover {
        cursor: pointer;
        color: $primary-color;
      }
    }
  }
}
</style>
